// Pixel values inspired by https://tailwindcss.com/docs/responsive-design#overview
export default {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
  '2xl': 1536, // Obsolete, please use 'xxl' instead
}
